<template>
  <v-row v-if="documentId && filename && showLabel">
    <v-col cols="10" sm="4">{{ label }}</v-col>
    <v-col cols="2" sm="1">:</v-col>
    <v-col cols="12" sm="7">
      <div class="mdr-file-preview-item">
        <v-icon color="red darken-1" class="mr-2">mdi-file-pdf-box</v-icon>
        <span class="file-name-text">{{ filename }}</span>
        <span v-if="suffix" class="red--text ml-2">( {{ suffix.toLowerCase() }} )</span>
        <v-btn
          icon
          small
          color="primary"
          :loading="loading"
          :disabled="loading"
          @click="downloadFile"
          title="Download"
          class="ml-2"
        >
          <v-icon small>mdi-download</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
  <!-- No label version -->
  <div v-else-if="documentId && filename && !showLabel" class="mdr-file-preview-item">
    <v-icon color="red darken-1" class="mr-2">mdi-file-pdf-box</v-icon>
    <span class="file-name-text">{{ filename }}</span>
    <span v-if="suffix" class="red--text ml-2">( {{ suffix.toLowerCase() }} )</span>
    <v-btn
      icon
      small
      color="primary"
      :loading="loading"
      :disabled="loading"
      @click="downloadFile"
      title="Download"
      class="ml-2"
    >
      <v-icon small>mdi-download</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'PdfDetailApi',
  props: {
    documentId: {
      type: [String, Number],
      default: null,
    },
    type: {
      type: String,
      default: 'custom_mdr',
    },
    filename: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Dokumen',
    },
    suffix: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    loading() {
      return this.$store.state.mdrFile?.loading || false;
    },
  },
  methods: {
    async downloadFile() {
      if (!this.documentId) return;

      await this.$store.dispatch('mdrFile/getMdrFile', {
        documentId: this.documentId,
        type: this.type,
        filename: this.filename,
      });
    },
  },
};
</script>

<style scoped>
.mdr-file-preview-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.file-name-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  word-break: break-all;
}
</style>
